module.exports = __webpack_public_path__ + "img/9791191826029.feb28fe3.jpg";